"use client";

import { Dialog } from "@tosize/ui";
import { useEffect, useState } from "react";
import Image from "~/components/utilities/Image";

export function ProseImage() {
	const [dialogImage, setDialogImage] = useState<HTMLImageElement | null>(null);

	useEffect(() => {
		const handleClick = (e: Event) => {
			if (e.target instanceof HTMLImageElement && e.target.closest(".prose")) {
				setDialogImage(e.target);
			}
		};

		document.addEventListener("click", handleClick);
		return () => document.removeEventListener("click", handleClick);
	}, []);

	return (
		<Dialog
			open={!!dialogImage}
			onOpenChange={() => setDialogImage(null)}
			title={dialogImage?.alt ?? dialogImage?.title ?? ""}
			width="full"
			height="full"
		>
			{dialogImage && (
				<div className="relative h-full w-full">
					<Image className="object-contain" src={dialogImage.src} alt={dialogImage.alt} fill />
				</div>
			)}
		</Dialog>
	);
}
